(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('orderToConsignments', {
        templateUrl: 'views/components/views/orderToConsignments/orderToConsignments.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', function ($stateParams) {
            const vm = this;
            let orderInternalNo = $stateParams.order_internal_no;
            let custactNoConsignmentPlan = $stateParams.custact_no_consignmentplan;

            vm.model = {};
        }]
    });
})();
